import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const KurszielServiceConfig = {
  name: "Kursziel",
  annotations: []
} as ServiceConfig;